import React, { InputHTMLAttributes, useEffect, useRef } from "react";
import { useField } from "@unform/core";

interface InputProps extends InputHTMLAttributes<HTMLSelectElement> {
  label?: string;
}

const Select: React.FC<InputProps> = ({ name, label, ...rest }) => {
  const { fieldName, defaultValue, registerField, error, clearError } =
    useField(name);

  const selectRef = useRef<HTMLSelectElement>(null);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: selectRef,
      getValue: (ref) => {
        return ref.current.value;
      },
      setValue: (ref, value) => {
        ref.current.value = value;
      },
      clearValue: (ref) => {
        ref.current.value = "";
      },
    });
  }, [fieldName, registerField]);

  return (
    <>
      {label && (
        <label
          htmlFor={fieldName}
          className={error ? "label has-text-danger-dark" : "label"}
        >
          {label}
        </label>
      )}
      <div
        className={error ? "select is-danger" : "select"}
        style={{ width: "100%" }}
      >
        <select
          ref={selectRef}
          defaultValue=""
          onChange={clearError}
          style={{ width: "100%" }}
        >
          <option disabled value="">
            Clique aqui para selecionar
          </option>
          <option value="M">Masculino</option>
          <option value="F">Feminino</option>
        </select>
      </div>
      {error && <small className="has-text-danger-dark">{error}</small>}
    </>
  );
};

export default Select;
